import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import OtherOption from '../OtherOption';
import { dispatchOptionField } from '../../../../Util/Util';

const RadioInput = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {form_component, option, checkedValue, setCheckedValue, formFields} = props;

	const optionFields = useSelector(state => state.optionFields);
	const curStep = useSelector(state => state.curStep);
	const jumpHistory = useSelector(state => state.jumpHistory) || [];

	useEffect(() => { // to be updated after render
		i18n.changeLanguage(props.lang);
	}, []);

	const onChange = (e) => {
		const {value} = e.target;
		
		// Get the selected option's jump conditions
		const selectedOption = option;
		const jumpConditions = {
			jump_to_session: selectedOption.jump_to_session || null,
			jump_to_se_index: selectedOption.jump_to_se_index || 0
		};
		
		setCheckedValue(value);
		dispatchOptionField(
			dispatch, 
			form_component, 
			value, 
			optionFields, 
			curStep, 
			formFields.form_components, 
			{...option, ...jumpConditions},  // Pass jump conditions with the option
			jumpHistory
		);
	};

	return (
		<>
		<input
			className={`form-check-input ${form_component.has_other_optionm ? 'has-other' : ''}`}
			type="radio"
			name={`${form_component.fieldname}`}
			id={`${form_component.fieldname}-${option.value}`}
			value={option.value}
			checked={checkedValue === option.value}
			onChange={onChange}
		/>
		<label className="form-check-label" htmlFor={`${form_component.fieldname}-${option.value}`}>
			<div className="d-flex gap-3 opt">
				<div className="x-radio"></div>
				<div className="ans">
					{option.value !== 'other' ? (
						<p className="mb-0">{option.label}</p>
					) : (
						<OtherOption
							key={`input-other`}
							lang={props.lang}
							form_component={form_component}
							checkedValue={checkedValue}
						/>
					)}
					<div className="pic w-100">
						
					</div>
				</div>
			</div>
		</label>
		</>
	);
}

export default RadioInput;